





export const variationBuilderHeading = "Build engaging classroom activities";

export const variationBuilderSubtitle =
"Design activities that drive concept clarity and student participation";

export const teachingConceptsHeading = "START WITH A CONCEPT YOU'RE TEACHING";

export { familiarTopics as teachingConcepts } from "../shared/familiarTopics";

export const knowledgeDepthOptions = [
{ id: "standard", label: "STANDARD" },
{ id: "creative", label: "CREATIVE" },
{ id: "technical", label: "TECHNICAL" }];


export const questionToneOptions = [
{ id: "mcq", label: "MCQ" },
{ id: "direct", label: "DIRECT" },
{ id: "conversational", label: "CONVERSATIONAL" }];


export const versionCountOptions = [2, 3, 4, 5];

export const generateVariationsHint =
"Creates a progression from basic understanding to deeper thinking";

export const generateVariationsLabel = "Generate Variations";

export const defaultQuestionVariationsConfig = {
  selectedConceptId: "",
  selectedConceptLabel: "",
  knowledgeDepth: ["creative"],
  questionTone: "mcq",
  versionCount: 5
};

export const generatingVariationsMessage = "Generating question variations…";